import { ServiceFetch } from '../service-fetch'

export default class PointExchangeProductListModel extends ServiceFetch {
    getPointExchangeProductListBy = (data) => this.authFetch({
        url: 'point-exchange-product-list/getPointExchangeProductListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}